import React, {useEffect, useRef, useState} from 'react';
import {Form, Button, Card} from 'react-bootstrap'
import axios from 'axios';
import Popup from 'reactjs-popup';
import {useHistory} from 'react-router-dom';
import * as XLSX from 'xlsx';
import {OutTable, ExcelRenderer} from 'react-excel-renderer';
import Spreadsheet from "react-spreadsheet";
import OverLay from '../overlay';
import './stamppaper.css'
import LoginByModal from './login_by_modal'
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

const StampPaper=(props)=>{
    const [loginornot, setloginornot]=useState(false)

    let choosexls=useRef(null)
    const history=useHistory()
    const popupmodal=useRef()
    const [indicator, setindecator]=useState(false)
    const [data, setdata]=useState([])
    const [SelectNoofstamppaper, setSelectnoofstamppaper]=useState('')
    const [checkrequest, setcheckedrequest]=useState(false)
    const [bulkupladdata, setbulkuploaddata]=useState(
        {xls_file:''}
    )
    const [getrequestdata, setgetrequestdata]=useState({})
    const [getrequestdata2, setgetrequestdata2]=useState({
        rows:{},
        cols:{}
    })
    
    const [spread, setspread]=useState([])
    // userData={props.userData}

    const [err, seterr]=useState({
        dataerr_0:{},
        dataerr_1:{}
    })
    const [err2, seterr2]=useState({})
    const [samedatachecked, setsamedatachecked]=useState(false);
    const [get_states, setget_states]=useState([
        {
            "id": 12,
            "name": "KARNATAKA"
        },
        {
            "id": 34,
            "name": "DELHI"
        },
        {
            "id": 7,
            "name": "GUJARAT"
        },
        {
            "id": 26,
            "name": "UTTAR PRADESH"
        },
        {
            "id": 8,
            "name": "HARYANA"
        },
        {
            "id": 14,
            "name": "MADHYA PRADESH"
        },
        {
            "id": 27,
            "name": "UTTARAKHAND"
        },
        {
            "id": 11,
            "name": "JHARKHAND"
        },
    ])
    const [get_city, setget_city]=useState([])
    const [get_city1, setget_city1]=useState([])


    const handleSubmit =(ev)=>{
        ev.preventDefault()
        let err={
            dataerr_0:{},
            dataerr_1:{}
        }
        data.forEach((dataval, i)=>{
            // pan_no_of_second_party
            if(!dataval.city.trim()){
                err['dataerr_'+i].city='Please Select city'
            }
            if(!dataval.service_type.trim()){
                err['dataerr_'+i].service_type='Please Select Service Type'
            }
            if(!dataval.pan_no_of_first_party.trim()){
                err['dataerr_'+i].pan_no_of_first_party='Please Enter Pan No of First party'
            }
            if(!dataval.pan_no_of_second_party.trim()){
                err['dataerr_'+i].pan_no_of_second_party='Please Enter Pan No of Second party'
            }
            if(!dataval.state.trim()){
                err['dataerr_'+i].state='Please Select state'
            }
            if(!dataval.name_of_first_party.trim()){
                err['dataerr_'+i].name_of_first_party='Please Enter Name of First Party'
            }
            if(!dataval.name_of_second_party.trim()){
                err['dataerr_'+i].name_of_second_party='Please Enter Name of Second Party'
            }
            if(!dataval.stamp_duty_paid_by.trim()){
                err['dataerr_'+i].stamp_duty_paid_by='Please Enter Stamp Paper Paid by'
            }
            if(dataval.state==='e'){
                if(!dataval.e_stamp_paper_value.trim()){
                    err['dataerr_'+i].e_stamp_paper_value='Please Enter E-Stamp Paper Value'
                }
                if(!dataval.no_of_e_stamp_paper.trim()){
                    err['dataerr_'+i].no_of_e_stamp_paper='Please Enter Number of E-Stamp paper'
                }
            }else{
                if(!dataval.stamp_paper_value.trim()){
                    err['dataerr_'+i].stamp_paper_value='Please Enter Stamp Paper Value'
                }
                // if(!dataval.no_of_stamp_paper.trim()){
                //     err['dataerr_'+i].no_of_stamp_paper='Please Enter No of Stamp Paper'
                // }
            }
            if(!dataval.document_description.trim()){
                err['dataerr_'+i].document_description='Please Write some document description'
            }
            if(!dataval.payment_method.trim()){
                err['dataerr_'+i].payment_method='Please Select Payment Method'
            }
            if(!dataval.delivery_address.trim()){
                err['dataerr_'+i].delivery_address='Please Enter Delivery Address'
            }
        })
        seterr({...err})
        if(Object.keys(err.dataerr_0).length===0&&Object.keys(err.dataerr_1).length===0){
            let ndata={data:data}
                ndata.user_id=props.userData.id
                ndata.scheme_id=props.userData.corporate_id

                // console.log(ndata)
            setindecator(true)
            axios.post('/post_new_service_request', ndata)
            .then(res=>{
                setindecator(false)
                if(res.data){
                    setgetrequestdata(res.data)
                    popupmodal.current.open()

                }
            }).catch((err)=>{
                setindecator(false)
            })
        }
    }

    const handleSubmitBulkUpload =(ev)=>{
        ev.preventDefault()
        let err2={}
        if(!bulkupladdata.xls_file.trim()){
            err2.xls_file='Please Upload File'
        }
        seterr2({...err2})
        if(Object.keys(err2).length===0){
            if(Object.keys(props.userData).length!==0){
                if(props.userData.id){
                    let getrequestdata2_main=getrequestdata2
                    getrequestdata2_main.rows.forEach(key=>{
                        key[8]=null;
                    })
                    // console.log('dssdmsdls', getrequestdata2_main)
                    let data=getrequestdata2
                        data.user_id=props.userData.id
                        data.scheme_id=props.userData.corporate_id
                        data.service_type=props.servicetype
                        setgetrequestdata2({...getrequestdata2, rows:{}, cols:{}})
                        if(choosexls.current!==null){
                            choosexls.current.value=""
                        }
                        setindecator(true)
                    axios.post('/request_bulk_upload', data)
                    .then((resp)=>{
                        setindecator(false)
                        if(resp.data){
                            setgetrequestdata(resp.data)
                            popupmodal.current.open()
                        }
                    }).catch((err)=>{
                        setindecator(false)
                    })
                }else{
                    alert('id', props.userData.id)
                }
                
            }
        }
    }
    const checkedsamedataalgo=()=>{
        let ndata=[...data]
        if(samedatachecked===false){
            ndata[1]=data[0]
        }else{
            ndata[1]= {
                service_type:props.servicetype,
                state:'',
                name_of_first_party:'',
                name_of_second_party:'',
                stamp_duty_paid_by:'',
                e_stamp_paper_value:'',
                stamp_paper_value:'',
                no_of_e_stamp_paper:'',
                no_of_stamp_paper:'',
                document_description:'',
                payment_method:'',
                delivery_address:'',
                pan_no_of_first_party:'',
                pan_no_of_second_party:'',
                fileuplaod:{},
                remarks:'',
                city:''
            }
        }
        setdata([...ndata])
    }
    const getBase64=(file)=>{
        return new Promise((resolve, reject)=>{
            const reader=new FileReader();
            reader.readAsDataURL(file);
            reader.onload=()=>resolve(reader.result)
            reader.onerror=error=>reject(error)
        })
    }
    const getstate=()=>{
        axios.get('/get_states').then((res)=>{
            // setget_states(res.data)
        })
    }
   const getcity=(id)=>{
    setindecator(true)
       axios.get('/get_cities_by_state?stateId='+id).then((res)=>{
        setindecator(false)
           setget_city(res.data.sort(function(a, b){
            // console.log(a, b)
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        
        }))
       }).catch((err)=>{
           if (err) throw err;
        setindecator(false)

       })
   }
   const getcity1=(id)=>{
    setindecator(true)
       axios.get('/get_cities_by_state?stateId='+id).then((res)=>{
        setindecator(false)
           setget_city1(res.data.sort(function(a, b){
            // console.log(a, b)
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        
        }))
       }).catch((err)=>{
           if (err) throw err;
        setindecator(false)

       })
   }
    useEffect(()=>{
        
        getstate()
    }, [])
    console.log('dlsdlk',data)
    return(
        <>
        <div style={{display:'flex',flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
            <div>
                <label>No Of {props.servicetype}</label>
                <select onChange={(ev)=>{
                    setSelectnoofstamppaper(ev.target.value)
                    console.log(ev.target.value)
                    let ndata=[...data];
                    if(ev.target.value==='1'){
                        if(ndata.length>1){
                            ndata=[
                                {
                                    service_type:props.servicetype,
                                    state:'',
                                    name_of_first_party:'',
                                    name_of_second_party:'',
                                    stamp_duty_paid_by:'',
                                    e_stamp_paper_value:'',
                                    stamp_paper_value:'',
                                    no_of_e_stamp_paper:ev.target.value,
                                    no_of_stamp_paper:ev.target.value,
                                    document_description:'',
                                    payment_method:'',
                                    delivery_address:'',
                                    pan_no_of_first_party:'',
                                    pan_no_of_second_party:'',
                                    fileuplaod:{},
                                    remarks:'',
                                    city:''
    
                                }
                            ]
                        }else{
                            ndata=[{
                                service_type:props.servicetype,
                                state:'',
                                name_of_first_party:'',
                                name_of_second_party:'',
                                stamp_duty_paid_by:'',
                                e_stamp_paper_value:'',
                                stamp_paper_value:'',
                                no_of_e_stamp_paper:ev.target.value,
                                no_of_stamp_paper:ev.target.value,
                                document_description:'',
                                payment_method:'',
                                delivery_address:'',
                                pan_no_of_first_party:'',
                                pan_no_of_second_party:'',
                                fileuplaod:{},
                                remarks:'',
                                city:''

                            }]
                        }
                        setdata([...ndata])

                        setcheckedrequest(false)
                        
                    }else if(ev.target.value==='2'){
                        if(ndata.length<2){
                            ndata=[{
                                service_type:props.servicetype,
                                state:'',
                                name_of_first_party:'',
                                name_of_second_party:'',
                                stamp_duty_paid_by:'',
                                e_stamp_paper_value:'',
                                stamp_paper_value:'',
                                no_of_e_stamp_paper:ev.target.value,
                                no_of_stamp_paper:ev.target.value,
                                document_description:'',
                                payment_method:'',
                                delivery_address:'',
                                pan_no_of_first_party:'',
                                pan_no_of_second_party:'',
                                fileuplaod:{},
                                remarks:'',
                                city:''
                            },
                            {
                                service_type:props.servicetype,
                                state:'',
                                name_of_first_party:'',
                                name_of_second_party:'',
                                stamp_duty_paid_by:'',
                                e_stamp_paper_value:'',
                                stamp_paper_value:'',
                                no_of_e_stamp_paper:ev.target.value,
                                no_of_stamp_paper:ev.target.value,
                                document_description:'',
                                payment_method:'',
                                delivery_address:'',
                                pan_no_of_first_party:'',
                                pan_no_of_second_party:'',
                                fileuplaod:{},
                                remarks:'',
                                city:''
                            }]
                            setdata([...ndata])
                        }
                        setcheckedrequest(false)

                    }else if(ev.target.value==='3'){
                        setcheckedrequest(true)
                    }else{
                        ndata=[]
                        setdata([...ndata])
                        setcheckedrequest(false)

                    }
                
                }} style={{
                    width:300, 
                    appearance:'auto'
                }} className="form-control">
                <option key='-1' value="">Select</option>
                <option key={1} value='1'>1</option>
                <option key={2} value='2'>2</option>
                <option key={3} value="3"> { ">" }2</option>
                </select>
            </div>

            <div>
                {data.length===2&&
                    <div>
                        {checkrequest===false&&
                        <div>
                            <input type={'checkbox'} checked={samedatachecked} onChange={(ev)=>{
                            setsamedatachecked(!samedatachecked)
                            checkedsamedataalgo()
                            }}  className="form-check-input"/>
                            {" "}
                            <label>
                                same as previous details
                            </label>                   
                        </div>}
                    </div>
                }
            </div>
        </div>
        {/*
            <div>
                <label style={{padding:10}}>
                    Request
                    <input onChange={()=>{
                        setcheckedrequest(false)
                    }} name='request'  type="radio" checked={checkrequest===false?true:false} />
                </label>
                <label style={{padding:10}}>
                    Bulk Uplaod
                    <input onChange={()=>{
                        setcheckedrequest(true)
                    }} name='request' type="radio" checked={checkrequest}/>
                </label>
            </div>
        */}
        {checkrequest?<div style={{padding:10}}>
            <form action='/' onSubmit={handleSubmitBulkUpload}>
                <div style={{display:'flex', alignItems:'center', justifyContent:'space-around'}}>
                    <div >
                        <input ref={choosexls} accept=".xls,.xlsx"  type="file" onChange={(ev)=>{
                            let file=ev.target.files[0]
                            ExcelRenderer(file, (err, resp) => {
                                if(err){
                                console.log(err);            
                                }
                                else{
                                    resp.cols[8]={name:"I", key:8}
                                    resp.rows.forEach((key, i)=>{
                                        // console.log('start',i)
                                        if(i!==0){
                                            key[8]=<div key={i}>
                                                <label htmlFor={'choosefile'+i}>Upload File</label>
                                                <input id={'choosefile'+i} onChange={(ev)=>{
                                                    
                                                    if(ev.target.files[0]){
                                                        let file=ev.target.files[0]
                                                        let reader=new FileReader()
                                                        reader.onload=()=>{
                                                            
                                                            
                                                            if(Object.keys(resp.rows).length!==0){
                                                                resp.rows[i][9]=reader.result.substr(reader.result.indexOf(',') + 1)
                                                                resp.rows[i][10]=file.type
                                                                setgetrequestdata2({...getrequestdata2, rows:resp.rows, cols:resp.cols})
                                                                }
                                                        }
                                                        if(file){
                                                            reader.readAsDataURL(file)
                                                        }
                                                    }
                                                }}
                                                style={{display:'none'}} type='file' key={i}/>
                                            </div>
                                        }
                                    })
                                   
                                    setgetrequestdata2({...getrequestdata2, rows:resp.rows, cols:resp.cols})
                                }
                            }); 
                            var reader = new FileReader();
                            // const rABS = !!reader.readAsBinaryString;
                            reader.onload = function(upload) {
                                setbulkuploaddata({...bulkupladdata, xls_file:upload.target.result})
                                // const wb=XLSX.read(upload.target.result, { type: rABS ? 'binary' : 'array', bookVBA : true });
                                // let wsname=wb.SheetNames[0]
                                // const ws=wb.Sheets[wsname]
                                // const data=XLSX.utils.sheet_to_json(ws, {header:1})
                                // setspread(data)
                                // console.log('sakmkmakaskmkasm',data)
                                // setbulkuploaddata({...bulkupladdata, xls_file:upload.target.result})

                                seterr2({...err2, xls_file:''})
                            };
                            reader.readAsDataURL(file)
                            // if (rABS) {
                            //     reader.readAsBinaryString(file);
                            //   } else {
                            //     reader.readAsArrayBuffer(file);
                            //   };
                        }}/>
                        {err2.xls_file&&
                            <span style={{color:'red'}}>{err2.xls_file}</span>
                            }
                            
                    </div>
                    <div>
                        <a style={{
                            color:'#0d6efd'
                        }} href='/download_sample_stamp_paper'>Click to download sample file</a>
                    </div>
                </div>
                <div style={{overflow:'auto', height:300, padding:10}}>
                {Object.keys(getrequestdata2.rows).length!==0&&
                    <OutTable style={{
                        textAlign:'center',

                    }} data={getrequestdata2.rows} columns={getrequestdata2.cols} 
                    tableClassName="ExcelTable2007" tableHeaderRowClass="heading" />
                }
                </div>
                {props.userData===''?
                    <Button  variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}}
                    onClick={(()=>{
                        setloginornot(true)
                    })}
                    >Login</Button>
                    
                    :
                    <Button type="submit" variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}} >Submit</Button>
                    }
            </form>
            
            </div>:
            


            <form action='/' onSubmit={handleSubmit} >
            <div style={{flexDirection:'row', display:'flex', justifyContent:'space-around', padding:10, background:"transparent", }}>
                {data.map((dataval, i)=>{
                  return  <div key={i}
                  style={{
                  
                    display:data.length===1&&'flex',
                    flexWrap:'wrap',
                //   flexDirection:"column",
                    alignItems:'baseline',
                    justifyContent:'space-between',
                    padding:10
                }}>



                <div className='column1 d-flex flex-column '>
                <div className=''>
                    <label>{props.servicetype} is available in only<br/> states listed here:</label>

                    <select
                    disabled={i===1&&samedatachecked}
                    value={dataval.state}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].state=ev.target.value
                            setdata([...ndata])
                            // console.log(ev.target)
                        // setselectstate(ev.target.value)
                        // setdata({...data, state:ev.target.value})
                        // seterr({...err, state:''})
                        const index = ev.target.selectedIndex;
                        const el = ev.target.childNodes[index]
                        const id =  el.getAttribute('id'); 
                        // console.log(dataval, i)
                        if(i===0){
                            getcity(id)
                        }else{
                            getcity1(id)
                        }
                        // console.log(id)
                    }}
                    style={{
                        width:300, 
                        appearance:'auto'
                    }} className="form-control" id="4">
                    <option key='-1' value=''>Select State</option>
                    {get_states.sort(function(a, b){
                        // console.log(a, b)
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    
                    }).map((stat, i)=>{
                        return(
                            <option value={stat.name} key={i} id={stat.id}>{stat.name}</option>
                        )
                    })}
                </select>
                {err['dataerr_'+i].state&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].state}</span>
                    }
                </div>
                <div>
                    <label>Name of First Party:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.name_of_first_party}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].name_of_first_party=ev.target.value
                            setdata([...ndata])
                            let nerr={...err}
                            err['dataerr_'+i].name_of_first_party=''
                            seterr({...nerr})
            
            
                    }} name="name_of_first_party" className="form-control"/>
                    {err['dataerr_'+i].name_of_first_party&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].name_of_first_party}</span>
                        }
                </div>
                <div>
                    <label>Pan No of First Party:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.pan_no_of_first_party}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].pan_no_of_first_party=ev.target.value
                            setdata([...ndata])
                            let nerr={...err}
                            err['dataerr_'+i].pan_no_of_first_party=''
                            seterr({...nerr})
            
            
                    }} name="pan_no_of_first_party" className="form-control"/>
                    {err['dataerr_'+i].pan_no_of_first_party&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].pan_no_of_first_party}</span>
                        }
                </div>
                <div>
                    <label>Stamp Duty paid by</label>
                    <div style={{width:300, justifyContent:'space-between', display:'flex'}}>
                        <span>
                            <input type="radio"
                            value='First Party'
                            disabled={i===1&&samedatachecked}
                            checked={data[i].stamp_duty_paid_by==='First Party'?true:false}
                            onChange={(ev)=>{
                                let ndata=[...data]
                                ndata[i].stamp_duty_paid_by=ev.target.value
                                setdata([...ndata])
                               
                        let nerr={...err}
                        err['dataerr_'+i].stamp_duty_paid_by=''
                        seterr({...nerr})
                            }}
                            name={"stamp_duty_paid_by"+i} aria-label="Stamp Duty paid by" />
                            <br/>
                            First Party
                        </span>
                        <span>
                            <input type="radio" disabled={i===1&&samedatachecked} value={'second Party'}
                            checked={data[i].stamp_duty_paid_by==='second Party'?true:false}

                            onChange={(ev)=>{
                                let ndata=[...data]
                                ndata[i].stamp_duty_paid_by=ev.target.value
                                setdata([...ndata])
                                // setdata({...data, stamp_duty_paid_by:ev.target.value})
                        // seterr({...err, stamp_duty_paid_by:''})
            
                        let nerr={...err}
                        err['dataerr_'+i].stamp_duty_paid_by=''
                        seterr({...nerr})
                            }} name={"stamp_duty_paid_by"+i} aria-label="Stamp Duty paid by"/>
                            <br/>
                            Second Party
                        </span>
                    </div>
                    {err['dataerr_'+i].stamp_duty_paid_by&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].stamp_duty_paid_by}</span>
                        }
                </div>
                <div>
                    <label>Stamp Paper Value:</label>
                    <OverlayTrigger placement='bottom' overlay={<Tooltip id="tooltip-disabled">Service charge is Rs.20</Tooltip>}>
                    <span className="">
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.stamp_paper_value} 
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].stamp_paper_value=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, stamp_paper_value:ev.target.value})
                        // seterr({...err, stamp_paper_value:''})
                        let nerr={...err}
                        err['dataerr_'+i].stamp_paper_value=''
                        seterr({...nerr})
                       
                    }} name='stamp_paper_value' className="form-control popup"/>

                        </span>
                    </OverlayTrigger>


                    {err['dataerr_'+i].stamp_paper_value&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].stamp_paper_value}</span>
                        }
                </div>
                <div>
                    <label>Delivery Address:</label>
            
                    <textarea disabled={i===1&&samedatachecked} value={dataval.delivery_address}
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].delivery_address=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, delivery_address:ev.target.value})
                        // seterr({...err, delivery_address:''})
            
                        let nerr={...err}
                        err['dataerr_'+i].delivery_address=''
                        seterr({...nerr})
                    }} style={{width:300}} name='delivery_address' className="form-control"/>
                    {err['dataerr_'+i].delivery_address&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].delivery_address}</span>
                        }
                </div>
                <div>
                    <label>Remarks:</label>
            
                    <textarea disabled={i===1&&samedatachecked} value={dataval.remarks}
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].remarks=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, document_description:ev.target.value})
                        // seterr({...err, document_description:''})
                        // let nerr={...err}
                        // err['dataerr_'+i].document_description=''
                        // seterr({...nerr})
            
                    }} style={{width:300}} name='remarks' className="form-control"/>
                   
                </div>

                </div>
                <div className='column2 d-flex flex-column'>
                <div>
                    <label>Select City:</label>
                    <select
                    disabled={i===1&&samedatachecked}
                    value={dataval.city}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].city=ev.target.value
                            setdata([...ndata])
                        // setselectstate(ev.target.value)
                        // setdata({...data, state:ev.target.value})
                        // seterr({...err, state:''})
            
                    }}
                    style={{
                        width:300, 
                        appearance:'auto'
                    }} className="form-control" id="1">
                    <option key='-1' value=''>Select City</option>
                    {i===0?
                        <>
                        {get_city.map((stat, i)=>{
                            return(
                                <option value={stat.name} key={i}>{stat.name}</option>
                            )
                        })}
                        </>:
                        <>
                        {get_city1.map((stat, i)=>{
                            return(
                                <option value={stat.name} key={i}>{stat.name}</option>
                            )
                        })}
                        </>
                    }
                </select>
                {err['dataerr_'+i].city&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].city}</span>
                    }
                </div>
                 <div>
                    <label>Name of Second Party:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.name_of_second_party}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].name_of_second_party=ev.target.value
                            setdata([...ndata])
                        // seterr({...err, name_of_second_party:''})
                        let nerr={...err}
                        err['dataerr_'+i].name_of_second_party=''
                        seterr({...nerr})
            
                    }} name="name_of_second_party" className="form-control"/>
                    {err['dataerr_'+i].name_of_second_party&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].name_of_second_party}</span>
                        }
                </div>
                <div>
                    <label>Pan No of Second Party:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.pan_no_of_second_party}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].pan_no_of_second_party=ev.target.value
                            setdata([...ndata])
                            let nerr={...err}
                            err['dataerr_'+i].pan_no_of_second_party=''
                            seterr({...nerr})
            
            
                    }} name="pan_no_of_second_party" className="form-control"/>
                    {err['dataerr_'+i].pan_no_of_second_party&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].pan_no_of_second_party}</span>
                        }
                </div>
                <div>
                <label>Payment Method:</label>
                <div style={{width:300, justifyContent:'space-between', display:'flex'}}>
                    <span>
                        <input type="radio" value={'Prepaid'}
                        onChange={(ev)=>{
                            // setdata({...data, payment_method:ev.target.value})
                            let ndata=[...data]
                            ndata[i].payment_method=ev.target.value
                            setdata([...ndata])
                            let nerr={...err}
                            err['dataerr_'+i].payment_method=''
                            seterr({...nerr})
                
                        }} name="payment_method" aria-label="payment_method"/>
                        <br/>
                        Prepaid 
                    </span>
                    <span>
                        <input type="radio" value='Post Paid'
                        onChange={(ev)=>{
                            // setdata({...data, payment_method:ev.target.value})
                            let ndata=[...data]
                            ndata[i].payment_method=ev.target.value
                            setdata([...ndata])
                            let nerr={...err}
                            err['dataerr_'+i].payment_method=''
                            seterr({...nerr})
                
                        }} name="payment_method" aria-label="payment_method"/>
                        <br/>
                        Post Paid 
                    </span>
                    <span>
                        <input type="radio" value='Wallet'
                        onChange={(ev)=>{
                            // setdata({...data, payment_method:ev.target.value})
                            let ndata=[...data]
                            ndata[i].payment_method=ev.target.value
                            setdata([...ndata])
                            let nerr={...err}
                            err['dataerr_'+i].payment_method=''
                            seterr({...nerr})
                
                        }} name="payment_method" aria-label="payment_method"/>
                        <br/>
                        Wallet
                    </span>
                </div>
                {err['dataerr_'+i].payment_method&&
                <span style={{color:'red'}}>{err['dataerr_'+i].payment_method}</span>
                }
            </div>
            <div>
                    <label>Document Description:</label>
            
                    <textarea disabled={i===1&&samedatachecked} value={dataval.document_description}
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].document_description=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, document_description:ev.target.value})
                        // seterr({...err, document_description:''})
                        let nerr={...err}
                        err['dataerr_'+i].document_description=''
                        seterr({...nerr})
            
                    }} style={{width:300}} name='document_description' className="form-control"/>
                    {err['dataerr_'+i].document_description&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].document_description}</span>
                        }
                </div>
                <div style={{paddingTop:15}}>
                <label>Upload Document:</label> <br></br>
                    <input id="image-file" disabled={i===1&&samedatachecked} type="file"  accept="application/pdf,application/vnd.ms-excel, image/gif, image/jpeg, image/png,.xls,.xlsx" onChange={(ev)=>{
                        let base64File={}
                        let file=null;
                        file=ev.target.files
                            for(let k=0;k<file.length;k++){
                                // console.log(file[k].type)
                                getBase64(file[k]).then((res)=>{
                                    base64File['file_'+k]={data:res.substr(res.indexOf(',') + 1), type:file[k].type}
                                })
                        } 
                        let ndata=[...data]
                        ndata[i].fileuplaod=base64File;
                        setdata([...ndata])
                    }} multiple/>  
                </div>
                <div>
                    <label></label>
            
                    {/* <textarea disabled={i===1&&samedatachecked} value={dataval.remarks}
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].remarks=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, document_description:ev.target.value})
                        // seterr({...err, document_description:''})
                        // let nerr={...err}
                        // err['dataerr_'+i].document_description=''
                        // seterr({...nerr})
            
                    }} style={{width:300}} name='remarks' className="form-control"/> */}
                   
                </div>

                
                </div>

                </div>
                })}

              </div>
                
                {SelectNoofstamppaper!==''&&
                <div style={{textAlign:'center', width:'100%', paddingTop:20}}>
                   
                 {Object.keys(props.userData).length===0?
                    <Button  variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}}
                    onClick={(()=>{
                        setloginornot(true)
                    })}
                    >Login</Button>
                    
                    :
                    <Button type="submit"  variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}} >Submit</Button>
                    }
                </div>
                }
            </form>


            
        }
            <Popup
                ref={popupmodal}
                // trigger={<button className="button"> Open Modal </button>}
                modal
                nested>
                {close => (
                    <div>
                        {getrequestdata.message&&
                            <h6 style={{
                                padding:33,
                                color:'blueviolet'
                            }}>Created with Request ID {getrequestdata.text}</h6>
                        }
                      <div style={{display:'flex',alignItems:'center', justifyContent:'space-around'}}>
                            <Button onClick={()=>{
                                close()
                                if(JSON.parse(SelectNoofstamppaper)===1){
                                    setdata([
                                        {
                                            service_type:props.servicetype,
                                            state:'',
                                            name_of_first_party:'',
                                            name_of_second_party:'',
                                            stamp_duty_paid_by:'',
                                            e_stamp_paper_value:'',
                                            stamp_paper_value:'',
                                            no_of_e_stamp_paper:'',
                                            no_of_stamp_paper:'',
                                            document_description:'',
                                            payment_method:'',
                                            delivery_address:'',
                                            pan_no_of_first_party:'',
                                            pan_no_of_second_party:'',
                                            fileuplaod:{},
                                            remarks:''
                                        }
                                    ])
                                }
                                else if(JSON.parse(SelectNoofstamppaper)===2){
                                    setdata([
                                        {
                                            service_type:props.servicetype,
                                            state:'',
                                            name_of_first_party:'',
                                            name_of_second_party:'',
                                            stamp_duty_paid_by:'',
                                            e_stamp_paper_value:'',
                                            stamp_paper_value:'',
                                            no_of_e_stamp_paper:'',
                                            no_of_stamp_paper:'',
                                            document_description:'',
                                            payment_method:'',
                                            delivery_address:'',
                                            pan_no_of_first_party:'',
                                            pan_no_of_second_party:'',
                                            fileuplaod:{},
                                            remarks:''
                                        },
                                        {
                                            service_type:props.servicetype,
                                            state:'',
                                            name_of_first_party:'',
                                            name_of_second_party:'',
                                            stamp_duty_paid_by:'',
                                            e_stamp_paper_value:'',
                                            stamp_paper_value:'',
                                            no_of_e_stamp_paper:'',
                                            no_of_stamp_paper:'',
                                            document_description:'',
                                            payment_method:'',
                                            delivery_address:'',
                                            pan_no_of_first_party:'',
                                            pan_no_of_second_party:'',
                                            fileuplaod:{},
                                            remarks:''
                                        }
                                    ])
                                }
                            }}>Continue</Button>
                            <Button onClick={()=>{
                                history.push('/reports')
                                history.go(0)
                            }}>Go To The Reports</Button>
                        </div>
                    </div>
                  )}
               
            </Popup>
                <OverLay active={indicator}/>
                <LoginByModal propsStateData={data} loginClick={loginornot} login_not={true} closeModal={(ev)=>{
                    console.log('props', props)
                    setloginornot(false)
                }}/>
        </>
    )
}
export default StampPaper;